module.exports = __webpack_public_path__ + "media/images/clients/repeat_app__arrow-44f5b53e93579f92e23072b7f9516311.png";